import { render, staticRenderFns } from "./NoPrimaryAccountModal.vue?vue&type=template&id=779face1&"
import script from "./NoPrimaryAccountModal.vue?vue&type=script&lang=js&"
export * from "./NoPrimaryAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./NoPrimaryAccountModal.vue?vue&type=style&index=0&id=779face1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports